export const gradeList = ['beginner_b', 'beginner_a', 'advanced_b', 'advanced_a', 'elite_b', 'elite_a'];